module.exports = __webpack_public_path__ + "static/media/upload_more.801a2596.svg";